import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { actions } from 'core/use-cases/combo';
import type { RootState } from 'core';

export const useRedirectToCombo = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    comboEditConfirmation: { comboCode },
  }: RootState['cart'] = useSelector((state: RootState) => state.cart);
  const comboPath = `/combo?q=${comboCode}`;
  return {
    redirectToCombo: () => {
      history.push(comboPath);
      dispatch(actions.comboRedirect());
    },
  };
};
